// extracted by mini-css-extract-plugin
module.exports = {"pop-make-section":"PopularMakes_pop-make-section__KQpGG"};